import React from 'react';
import { Paper, Stack, Box, Typography } from '@mui/material';
import { AccountIndustry } from '../../../../utils/enums';

const BasicDetails = ({ data }) => {

    // if (!data) {
    //     // Display a loading indicator or a message if data is not available
    //     return (
    //         <Paper elevation={0} sx={{ p: 2, textAlign: 'center' }}>
    //             {/* <CircularProgress /> */}
    //             <Typography variant="body2">Loading data...</Typography>
    //         </Paper>
    //     );
    // }

    return (
        <Paper elevation={0} sx={{ p: 2 }}>
            <Stack direction="column" alignItems="center" spacing={2}>
                <Box display="flex" alignItems="center" justifyContent="center" width="100%">
                    <Box display="flex" justifyContent="flex-end" width="40%">
                        <span>Account Owner:</span>
                    </Box>
                    <Box display="flex" justifyContent="flex-start" width="60%">
                        <span style={{ marginLeft: '20px' }}>{data?.ownerName || '—'}</span>
                    </Box>
                </Box>
                <Box display="flex" alignItems="center" justifyContent="center" width="100%">
                    <Box display="flex" justifyContent="flex-end" width="40%">
                        <span>Industry:</span>
                    </Box>
                    <Box display="flex" justifyContent="flex-start" width="60%">
                        <span style={{ marginLeft: '20px' }}>{AccountIndustry[data?.industry]?.label ?? '—'}</span>
                    </Box>
                </Box>
                <Box display="flex" alignItems="center" justifyContent="center" width="100%">
                    <Box display="flex" justifyContent="flex-end" width="40%">
                        <span>Employees:</span>
                    </Box>
                    <Box display="flex" justifyContent="flex-start" width="60%">
                        <span style={{ marginLeft: '20px' }}>{data?.employees ?? '—'}</span>
                    </Box>
                </Box>
                <Box display="flex" alignItems="center" justifyContent="center" width="100%">
                    <Box display="flex" justifyContent="flex-end" width="40%">
                        <span>Annual Revenue:</span>
                    </Box>
                    <Box display="flex" justifyContent="flex-start" width="60%">
                        <span style={{ marginLeft: '20px' }}>$ {data?.annualRevenue.toFixed(2) ?? '—'}</span>
                    </Box>
                </Box>
                <Box display="flex" alignItems="center" justifyContent="center" width="100%">
                    <Box display="flex" justifyContent="flex-end" width="40%">
                        <span>Phone:</span>
                    </Box>
                    <Box display="flex" justifyContent="flex-start" width="60%">
                        <span style={{ marginLeft: '20px' }}>{data?.phone ?? '—'}</span>
                    </Box>
                </Box>
            </Stack>
        </Paper>
    )
}

export default BasicDetails;